export default __webpack_public_path__ + "static/media/3.d6a211ad.png";